// extracted by mini-css-extract-plugin
export default {"backButton":"backButton_backButton__-GsGk","arrowLeftLong":"backButton_arrowLeftLong__EmlXQ"};